export default "__VITE_ASSET__B9wPS05B__ 800w, __VITE_ASSET__UP4$H1kq__ 1280w, __VITE_ASSET__9aVL482F__ 1920w";